import Table from "components/data/Table";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";
import { Col, Typography } from "antd";

import { useDiscountCodeColumns, useDiscountCodeList } from "./hooks";

const DiscountCodeList: React.FC = () => {
  const columns = useDiscountCodeColumns();
  const discountCodeList = useDiscountCodeList();

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage defaultMessage="Discount Codes" />
          </Typography.Title>
        </Col>
        <Col>
          <ButtonLink type="primary" to={ROUTE_PATHS.DiscountCodeCreate}>
            <FormattedMessage defaultMessage="Add new Discount Code" />
          </ButtonLink>
        </Col>
      </Header>
      <Table rowKey="id" columns={columns} {...discountCodeList} />
    </>
  );
};

export default DiscountCodeList;
